import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const MyAcademyService = sdk.getService('MyAcademyService');

export const useMyAcademyStatsDetail = () => {
  const queryKey = ['academies', 'detail', 'stats'];
  const { isLoading, data } = useQuery({
    queryKey,
    queryFn: () => MyAcademyService.getAcademyStats()
  });

  return {
    stats: data,
    isLoading
  };
};
